import TitleBar from '../../../components/TitleBar';

import { ColumnsType } from 'antd/es/table';

import {
  CREATE_MITIGATOR,
  DELETE_MITIGATOR,
  EDIT_MITIGATOR,
  FETCH_MITIGATOR,
} from '../queries';
import { useMutation, useQuery } from '@apollo/client';
import { phoneFormatter, tableSortingMethods } from '../../../utils';
import TableV3 from '../../../components/generic/Table/TableV3';
import { Footer } from '../../../components';
import { formFields } from './forms/formFields';
import { baseColumns } from './exportColumns';
import QueryErrorBoundary from '../../../components/error-handling';
import TitleUpdater from '../../../components/common/TitleUpdater';

type FindAllMitigators = {
  vendorName: string;
  contactName: string;
  email: string;
  phone: string;
  uuid: string;
};

interface DataReturned {
  findAllMitigators: FindAllMitigators[];
}

function MitigatingLocations() {
  const { data, loading, error } = useQuery<DataReturned>(FETCH_MITIGATOR);

  const [createMitigator] = useMutation(CREATE_MITIGATOR, {
    refetchQueries: ['GetMitigator', 'GetMitigators'],
  });

  const [updateMitigator] = useMutation(EDIT_MITIGATOR, {
    refetchQueries: ['GetMitigator', 'GetMitigators'],
  });

  const [deleteMitigador] = useMutation(DELETE_MITIGATOR, {
    refetchQueries: ['GetMitigator', 'GetMitigators'],
  });

  const columns: ColumnsType<FindAllMitigators> = [
    {
      title: 'Vendor',
      dataIndex: 'vendorName',
      key: 'vendorName',
      align: 'left',
      width: 150,
      sorter: (a, b) => tableSortingMethods.string(a.vendorName, b.vendorName),
      render: (text: string) => (
        <span className="custom-table--column">{text}</span>
      ),
    },
    {
      title: 'Contact Name',
      dataIndex: 'contactName',
      key: 'contactName',
      align: 'left',
      width: 150,
      sorter: (a, b) =>
        tableSortingMethods.string(a.contactName, b.contactName),
      render: (text: string) => (
        <span className="custom-table--column">{text}</span>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      align: 'left',
      width: 100,
      sorter: (a, b) => tableSortingMethods.string(a.email, b.email),
      render: (text: string) => (
        <span className="custom-table--column">{text}</span>
      ),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      align: 'left',
      width: 100,
      sorter: (a, b) => tableSortingMethods.string(a.phone, b.phone),
      render: (text: string) => (
        <span className="custom-table--column">{phoneFormatter(text)}</span>
      ),
    },
  ];

  return (
    <>
      <TitleUpdater title="Vendors" />
      <TitleBar
        title="Data Inputs"
        subtitle="Mitigating Locations"
        brief="The following is a list of external locations that have been identified as critical in supporting your
        mitigation strategies to reduce the impact on your business when a disruption occurs. While you can edit the
        location data here, you can add locations to this list as you work through the quantification of mitigation."
      />
      <QueryErrorBoundary error={error}>
        <TableV3
          title="Vendors/Mitigators"
          columns={columns}
          data={data?.findAllMitigators}
          loading={loading}
          editable
          formFields={formFields}
          createGQL={createMitigator}
          updateGQL={updateMitigator}
          deleteGQL={deleteMitigador}
          exportExcelColumns={baseColumns}
        />
      </QueryErrorBoundary>
      <Footer backPath="/data-inputs" />
    </>
  );
}

export default MitigatingLocations;
